import _ from "lodash";
import store from "services/redux/store";
import { addDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchRoom from "utils/fetch/FetchRoom";

export default class FetchCachedRoom
{
	static logName = 'FetchCachedMyBooking';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'rooms',
				tables: [ 'office_room' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( { callbackSuccess, callbackError, callbackStart } )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchRoom.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( rooms ) => {
						// Save to object
						this.process( rooms );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, rooms, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( rooms );
						}
					}
				})
			);
		}
		);
	}

	static process = ( rooms ) => {
		this.values = rooms;
		store.dispatch( addDataByGuid( dataConstants.ROOMS, this.values ) );
	}
}
